export const byStringified = <T,>(needle?: T) => (hay: T) =>
  `${needle}` === `${hay}`;
